export const OVERALL_STATUS = {
  COMPLETE: "Completed",
  NOT_START: "Not started",
  IN_PROGRESS: "In Progress",
};